import SellerDetailsCard from './SellerDetailsCard.component';

export default SellerDetailsCard;
